import React from "react";
import dayjs from "dayjs";

function pickWeatherImage(a) {
	let weather = "sun";
	switch (a.weather_conditions) {
		case "DAWN":
			weather = "dawn";
			break;

		case "RAIN":
			weather = "rain";
			break;

		case "DARK, NOT LIGHTED":
		case "DARK, UNKNOWN LIGHTING":
			weather = "moon";
			break;

		case "DUSK":
		case "DARK, LIGHTED":
			weather = "dusk";
			break;

		case "SNOW":
		case "SLUSH":
		case "ICE":
			weather = "snow";
			break;

		case "SLEET/HAIL":
		case "WET":
		case "STANDING WATER":
			weather = "sleet";
			break;

		case "SAND, MUD, DIRT":
			weather = "dirt";
			break;

		case "FOG":
			weather = "fog";
			break;

		case "SEVERE CROSSWINDS":
		case "BLOWING SAND/SNOW":
			weather = "severe-crosswinds";
			break;

		case "CLEAR":
		case "DRY":
			if (dayjs(a.date).get("hour") > 21 || dayjs(a.date).get("hour") < 6) {
				weather = "moon";
			} else {
				weather = "sun";
			}
			break;

		case "CLOUDY":
		case "CLOUDY also light condition types:UNKNOWN":
			if (dayjs(a.date).get("hour") > 21 || dayjs(a.date).get("hour") < 6) {
				weather = "night-cloudy";
			} else {
				weather = "day-cloudy";
			}
			break;

		default:
			weather = "sun";
	}

	return weather;
}

export default function WeatherIcon({ a }) {
	return (
		<img
			src={`/assets/weather/icon-${pickWeatherImage(a)}.svg`}
			alt="Weather and Traffic icon"
		/>
	);
}
